module.exports = __webpack_public_path__ + "static/media/compare_1.1dda81f8.svg";